import { forwardRef } from "react";
import styled from "styled-components/macro";
import { Link, LinkProps, Router } from "react-router-dom";
import { THEME_COLOR_DARK, THEME_COLOR } from "../vars";
import useRootHistory from "../hooks/use-root-history";

const Anchor = styled(Link)`
  color: ${THEME_COLOR_DARK};
  text-decoration: none;
  transition: color 0.2s ease-out;
  font-weight: 500;
  border-bottom: 1px dotted #ccc;
  &:hover,
  &:focus {
    border-bottom-color: ${THEME_COLOR};
    border-bottom-style: solid;
    color: ${THEME_COLOR_DARK};
    text-decoration: none;
  }
`;

export const RootAnchor = forwardRef<HTMLAnchorElement, LinkProps>(
  function RootAnchor(props, ref) {
    const history = useRootHistory();
    return (
      <Router history={history}>
        <Anchor {...props} ref={ref} />
      </Router>
    );
  }
);

export default Anchor;
